/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_UpdatePortfolioScaleRequest = {
    expected_updated_at: string;
    is_active: boolean;
    label_default: string;
    label_translations?: Record<string, string>;
    scale_type: portfolio_UpdatePortfolioScaleRequest.scale_type;
    sort_order?: number;
};
export namespace portfolio_UpdatePortfolioScaleRequest {
    export enum scale_type {
        BINARY = 'binary',
        TRI_STATE = 'tri_state',
        LIKERT_4 = 'likert_4',
        ORDINAL_5 = 'ordinal_5',
        NARRATIVE_ONLY = 'narrative_only',
    }
}

